import React from "react";
import { useAuth } from "../../../contexts/auth.context";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { siteSettings } from "../../../settings/site-settings";

const Navbar = () => {
  const { logOut } = useAuth();
  return (
    <nav className="flex select-none  h-[48px] items-center justify-between gap-2 bg-blackLight px-5 text-white border-b border-borderColor">
      <div className="w-1/3 h-full flex items-center">
        <img src={siteSettings.logo} alt="logo" className="h-7 /ml-2" />
      </div>

      <RiLogoutCircleRLine
        title="Logout"
        onClick={() => {
          logOut();
        }}
        size={26}
        className="text-body hover:cursor-pointer hover:text-primary"
      />
    </nav>
  );
};

export default Navbar;
